import { store } from '../store';
import { showPopup, closePopup } from '../actions/popup.action';

interface PopupData {
  component?: () => any,
  settings: any;
  type: 'info' | 'input' | 'component';
}
export default class Popup {
  static hide() { return store.dispatch(closePopup()) }
  static show(popup: PopupData) { return store.dispatch(showPopup(popup)) }
}
